import { identity, merge } from "lodash";
import { generateEndpoints, prefix } from "../helpers";

/**
 * This is the reource identifier
 * Everything will be under users.get, users.getAll, users.create, users.createAndSendEmail etc...
 */
const namespace = "validation";

const nameSpace = merge({}, generateEndpoints(namespace), {
  get: {
    organizationValidationVAT: ({ vat, excluding = null }) => {
      let url = `${prefix}/profile/organization/checkvat/${vat}`
      if (excluding != null) {
        url += `?exclude=${excluding}`
      }
      return [url]
    }
  },
  post: {
    userUniqueEmail: ({ value, excluding, mapper = identity }) => [
      `${prefix}/profile/validate`,
      {
        type: "userUniqueEmail",
        value: mapper(value),
        excluding,
      },
    ],
    userUniquePhone: ({ value, excluding, mapper = identity }) => [
      `${prefix}/profile/validate`,
      {
        type: "userUniquePhone",
        value: mapper(value),
        excluding,
      },
    ],
  },
});

export default nameSpace;
